import { memo } from "react";

function Icon_MidstreamNetwork() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_69_52)">
        <path
          d="M16 5.98438H10.5156C10.2398 5.98418 10.0158 5.76022 10.0156 5.48438V3.68262H4.60938L13.5625 12.3193C13.7092 12.4609 13.756 12.6772 13.6797 12.8662C13.6033 13.0551 13.4195 13.1787 13.2158 13.1787H6.73633C6.46464 14.7803 5.0715 16 3.39258 16C1.51892 16 2.63673e-05 14.4811 0 12.6074C-8.19011e-08 10.7337 1.5189 9.21487 3.39258 9.21484C5.12101 9.21484 6.54603 10.5075 6.75684 12.1787H11.9766L3.02539 3.54199C2.87874 3.40051 2.83203 3.1841 2.9082 2.99512C2.98455 2.80623 3.16833 2.68267 3.37207 2.68262H10.0156V0H16V5.98438Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_69_52">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(Icon_MidstreamNetwork);
